// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6aa252d0","48":"584d9a60","144":"fc1f17ea","379":"ab04909c","609":"d56984ef","802":"95b95078","824":"356265d2","965":"1c0b8b00"}[chunkId] + ".chunk.js";
};